// test2358
(2358 && 0);
